import type { FC } from "react";
import styles from "@/pages/CampaignOverviewPage/components/AudienceSegmentTable.module.css";
import { fmt, integerFormatter } from "@/utils/tableFormatters";

interface ImpressionsBarCellProps {
  // The column's largest value, so every bar is scaled against the biggest
  // segment in the table.
  max: number;
  value: number | null | undefined;
}

const ImpressionsBarCell: FC<ImpressionsBarCellProps> = ({ max, value }) => {
  const impressions = value ?? 0;
  return (
    <div className={styles.impressionsCell}>
      <span className={styles.track}>
        {impressions > 0 && max > 0 && (
          <span
            className={styles.bar}
            style={{ width: `${(impressions / max) * 100}%` }}
          />
        )}
      </span>
      <span className={styles.impressionsValue}>
        {fmt(value, integerFormatter)}
      </span>
    </div>
  );
};

export default ImpressionsBarCell;
